import { VHPlayerEventBusContext } from '@vh/contexts/VHPlayerEventBus/VHPlayerEventBus.context';
import { virtualHumanTalkingSelector } from '@vh/slices/chat/ChatSlice';
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useSelector } from 'react-redux';
import * as Styled from './SkipTalkingButton.styled';
import { useTranslation } from 'react-i18next';

const SHOW_SKIP_BUTTON_AFTER_MS = 5000;

const SkipTalkingButton = () => {
  const skipTimeoutMS = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.has('skipTimeout')) {
      return params.get('skipTimeout');
    }
    return SHOW_SKIP_BUTTON_AFTER_MS;
  }, []);
  const { emit } = useContext(VHPlayerEventBusContext);
  const handleStopVirtualHumanTalkingClick = useCallback(() => {
    emit('StopVirtualHumanTalking');
  }, [emit]);

  const virtualHumanTalking = useSelector(virtualHumanTalkingSelector);
  const [showSkipButton, setShowSkipButton] = useState(false);
  const showSkipButtonTimer = useRef(
    /** @type {NodeJS.Timeout | null} */ (null)
  );

  useEffect(() => {
    if (showSkipButtonTimer.current) {
      clearTimeout(showSkipButtonTimer.current);
    }

    if (!virtualHumanTalking) {
      setShowSkipButton(false);
      return;
    }

    showSkipButtonTimer.current = setTimeout(() => {
      setShowSkipButton(true);
    }, skipTimeoutMS);
  }, [virtualHumanTalking, skipTimeoutMS]);

  const { t } = useTranslation();

  return (
    <Styled.StopAudioButton
      $show={showSkipButton}
      iconSize={'12px'}
      color="white"
      onClick={handleStopVirtualHumanTalkingClick}
      aria-label={t('skip')}
    >
      {t('skip')}
    </Styled.StopAudioButton>
  );
};

export default SkipTalkingButton;
